import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {AnalyticsService} from "../../services/analytics-service.service";

export class AddressAutocompleteComponent implements IController {

  address: any;
  country: any;
  mdRequireMatch: any;
  noMargin: any;
  isDisabled: any;
  onChange: Function;
  onReady: Function;
  required: string;

  autocompleteService = new google.maps.places.AutocompleteService();
  placesService = new google.maps.places.PlacesService(document.createElement('div'));
  types: any[] = ['geocode'];
  selectedItem: any;
  searchText: any;

  constructor(private $log, private $q: IQService, private $filter, private analyticsService: AnalyticsService) {
  }

  $onInit() {
    this.setSelectedItem();
  }

  $onChanges(changes) {
    if (changes.address && !changes.address.isFirstChange()) {
      this.$onInit();
    }
  }

  $postLink() {
    if (_.isFunction(this.onReady)) {
      this.onReady();
    }
  }

  setSelectedItem() {
    let address = this.$filter('bringozAddress')(this.address, true);
    if (address) {
      this.selectedItem = {
        description: address
      };
    } else {
      this.selectedItem = undefined;
    }
  }

  selectedItemChange(item) {
    if (item) {
      if (!item.place_id) return;
      this.geocode(item.place_id).then((place) => {
        let address = this.placeToAddress(place);
        this.onChange({address: address});
      }, () => {
        this.$log.error('selectedItemChange fail');
      });
    } else {
      this.onChange({address: undefined});
    }
  }

  geocode(placeId) {
    let deferred = this.$q.defer();

    this.placesService.getDetails({placeId: placeId, fields: ['address_components', 'formatted_address', 'geometry', 'place_id']}, (place, status) => {
      this.analyticsService.trackEvent('Geocode', 'addressAutocomplete', status);
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        deferred.resolve(place);
      } else {
        this.$log.error('geocode fail', status);
        deferred.reject(status);
      }
    });

    return deferred.promise;
  }

  querySearch(query) {
    return this.getPlacePredictions(query, this.types);
  }

  getPlacePredictions(input, types) {
    let deferred = this.$q.defer();
    let query = {
      input: input,
      types: types,
      componentRestrictions: null
    };

    if (this.country) {
      query.componentRestrictions = {
        country: [this.country]
      }
    }

    this.autocompleteService.getPlacePredictions(query, (predictions, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        deferred.resolve(predictions);
      } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        if (!this.mdRequireMatch) {
          this.onChange({address: {}, searchText: this.searchText});
        }
        deferred.resolve([]);
      } else {
        this.$log.error('getPlacePredictions fail', status);
        deferred.reject(status);
      }
    });
    return deferred.promise;
  }

  placeToAddress(place) {

    if (place.address_components.length < 3) return {};

    function getTypeValue(type) {
      for (var i = 0; i < place.address_components.length; i++) {
        var component = place.address_components[i];
        for (var j = 0; j < component.types.length; j++) {
          var componentType = component.types[j];
          if (componentType === type) {
            return component.long_name;
          }
        }
      }
      return undefined;
    }

    return {
      house: getTypeValue('street_number'),
      neighborhood: getTypeValue('neighborhood'),
      street: getTypeValue('route') || getTypeValue('neighborhood'),
      city: getTypeValue('locality') || getTypeValue('sublocality'),
      country: getTypeValue('country'),
      state: getTypeValue("administrative_area_level_1"),
      location: {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        longitude: place.geometry.location.lng(),
        latitude: place.geometry.location.lat()
      },
      zipCode: getTypeValue('postal_code'),
      place: place.formatted_address,
      placeId: place.place_id
    };

  }
}

angular
  .module('bringoz.admin.commons')
  .component('addressAutocomplete', {
    require: {
      form: '^form'
    },
    bindings: {
      address: '<',
      country: '<?',
      isDisabled: '<?',
      mdRequireMatch: '<',
      noMargin: '<?',
      onChange: '&',
      onReady: '&?',
      required: '@?'
    },
    templateUrl: 'app/modules/commons/components/address-autocomplete/address-autocomplete.html',
    controller: AddressAutocompleteComponent
  });
